"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var QuestionType;
(function (QuestionType) {
    QuestionType["StandardQuestion"] = "StandardQuestion";
    QuestionType["Standard5Question"] = "Standard5Question";
    QuestionType["Budget5Question"] = "Budget5Question";
})(QuestionType = exports.QuestionType || (exports.QuestionType = {}));
var ElectionStatus;
(function (ElectionStatus) {
    ElectionStatus["PREPARATION"] = "PREPARATION";
    ElectionStatus["UPCOMING"] = "UPCOMING";
    ElectionStatus["LIVE_CANDIDATE"] = "LIVE_CANDIDATE";
    ElectionStatus["LIVE_VOTER"] = "LIVE_VOTER";
    ElectionStatus["AFTER_ELECTION"] = "AFTER_ELECTION";
    ElectionStatus["ARCHIVED"] = "ARCHIVED";
    ElectionStatus["INVISIBLE"] = "INVISIBLE";
    ElectionStatus["REMOVED"] = "REMOVED";
    ElectionStatus["LEGACY"] = "LEGACY";
})(ElectionStatus = exports.ElectionStatus || (exports.ElectionStatus = {}));
//# sourceMappingURL=interfaces.js.map